import React from 'react';
import { FileUpload, PreviewFile } from '../../../components/files/FilesUpload';
import { useAppContext } from '../../../contexts/AppContext';
import { Image } from 'lucide-react';

interface FormPlanoImagesProps {
    value: any[];
    setValue: (files: any[]) => void;
    disabled?: boolean;
    onUploadingChange?: (loading: boolean) => void;
}

export default function FormPlanoImages({ value, setValue, disabled = false, onUploadingChange }: FormPlanoImagesProps) {
    const { errorSnackbar } = useAppContext();

    return (
        <FileUpload
            key={`${!!value?.length}`}
            value={value}
            setValue={setValue}
            disabled={disabled}
            onLoadingChange={onUploadingChange}
        >
            {({ fileData, handleChange, removeFile, inputRef, loading }: any) => {
                const maxFiles = 5;

                const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                    const selectedFiles: any[] = Array.from(e.target.files || []);
                    const availableSlots = maxFiles - fileData.length;

                    if (availableSlots <= 0) {
                        errorSnackbar(`Você já atingiu o limite de ${maxFiles} imagens.`);
                        return;
                    }

                    const filesToUpload = selectedFiles.slice(0, availableSlots);

                    // 👇 aqui é onde o TS reclamava
                    (handleChange as any)(filesToUpload);
                };

                return (
                    <div className="pla-images">
                        {fileData.length > 0 && (
                            <div className="flow-root">
                                {fileData.map((file: any) => (
                                    <PreviewFile key={file.id} fileData={file} onRemove={removeFile} />
                                ))}
                            </div>
                        )}

                        {fileData.length < maxFiles && (
                            <>
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={inputRef}
                                    multiple
                                    disabled={loading || disabled}
                                    className="hidden"
                                    onChange={handleFileChange}
                                />
                                <button
                                    type="button"
                                    className="estab-link-button"
                                    disabled={loading || disabled}
                                    onClick={() => inputRef.current?.click()}
                                >
                                    <Image aria-hidden />
                                    Adicionar imagem
                                </button>
                            </>
                        )}
                    </div>
                );
            }}
        </FileUpload>
    );
}
